'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".TrackingNumber-module_container__aasGU{width:100%}.TrackingNumber-module_imgWrapper__p81wj{align-items:center;display:flex}.TrackingNumber-module_carrierImg__tRcSD{max-height:2.5rem}";
var styles = {"container":"TrackingNumber-module_container__aasGU","imgWrapper":"TrackingNumber-module_imgWrapper__p81wj","carrierImg":"TrackingNumber-module_carrierImg__tRcSD"};
styleInject["default"](css_248z, 'da08067a-f5ac-4a83-81bf-e3ac2ed970e3');

exports["default"] = styles;
